export function getPositionFullName(position: string) {
  switch (position.toLowerCase()) {
    case 'hb':
      return 'Running Back'
    case 'wr':
      return 'Wide Receiver'
    case 'te':
      return 'Tight End'
    case 'c':
      return 'Center'
    case 'lg':
      return 'Left Guard'
    case 'rg':
      return 'Right Guard'
    case 'lt':
      return 'Left Tackle'
    case 're':
      return 'Right Tackle'
    case 'qb':
      return 'Quarterback'
    case 'fb':
      return 'Full Back'
    case 'g':
      return 'Guard'
    case 't':
      return 'Tackle'
    case 'cb':
      return 'Cornerback'
    case 'lb':
      return 'Linebacker'
    case 's':
      return 'Safety'
    case 'di':
      return 'Interior Defender'
    case 'ed':
      return 'Edge Defender'
    case 'k':
      return 'Kicker'
    case 'p':
      return 'Punter'
    default:
      return undefined
  }
}
